"use client"

import { useEffect, useRef } from "react"
import { usePathname } from "next/navigation"
import { trackActivity } from "@/lib/client/activity"

const PUBLIC_PATHS = new Set(["/login", "/register", "/admin/login"])

export function ActivityTracker() {
  const pathname = usePathname()
  const previousPath = useRef<string | null>(null)

  useEffect(() => {
    if (!pathname || PUBLIC_PATHS.has(pathname) || previousPath.current === pathname) return
    previousPath.current = pathname
    trackActivity({
      event_name: "page.viewed",
      category: "navigation",
      page: pathname,
      route: pathname,
      metadata: { source: "next_navigation" },
    })
  }, [pathname])

  return null
}
